import analysis from './analysis'
import contextMenu from './context-menu'
import criteriaSet from './criteria-set'
import evaluationOverride from './evaluation-override'
import logoUpload from './logo-upload'
import management from './management'
import panels from './panels'
import preview from './preview'
import republish from './republish'
import sharingOptions from './sharing-options'
import status from './status'
import titleDescription from './title-description'

export default {
    analysis,
    contextMenu,
    criteriaSet,
    evaluationOverride,
    logoUpload,
    management,
    panels,
    preview,
    republish,
    sharingOptions,
    status,
    titleDescription
}
